import Mapper from '@web/mapper/Mapper'
import camelCase from 'lodash.camelcase'
import Time from '@web/common/Time'

function camelize (value: unknown): unknown {
  if (Array.isArray(value)) {
    return value.map(camelize)
  }
  if (value !== null && typeof value === 'object') {
    const obj = value as Record<string, unknown>
    const result: Record<string, unknown> = {}
    for (const key of Object.keys(obj)) {
      result[camelCase(key)] = camelize(obj[key])
    }
    return result
  }
  return value
}

function normalizeConfig (config: unknown): StepConfig | undefined {
  if (Array.isArray(config)) return undefined
  if (config !== null && typeof config === 'object') {
    return camelize(config) as StepConfig
  }
  return undefined
}

export default class SubscriptionMapper extends Mapper {
  static toClient (data: unknown): RawSubscription {
    const convertedData = SubscriptionMapper.converter({
      data,
      rules: {
        period: {
          rename: 'interval'
        },
        period_count: {
          rename: 'period'
        },
        activeFreeze: {
          cb: activeFreeze => {
            if (!activeFreeze) return undefined

            return {
              id: activeFreeze.id,
              scheduledAt: activeFreeze.scheduled_at ? activeFreeze.scheduled_at * 1000 : undefined,
              startedAt: activeFreeze.started_at ? activeFreeze.started_at * 1000 : undefined,
              expiresAt: activeFreeze.expires_at ? activeFreeze.expires_at * 1000 : undefined,
              endedAt: activeFreeze.ended_at ? activeFreeze.ended_at * 1000 : undefined
            }
          }
        },
        offboarding: {
          cb: (offboarding: Record<string, unknown> | null | undefined) => {
            if (!offboarding) return undefined
            const rawSteps = Array.isArray(offboarding.steps) ? offboarding.steps as Array<Record<string, unknown>> : []
            // Пустой/невалидный steps → трактуем offboarding как отсутствующий,
            // иначе подписка считается суперподпиской, но воронка пуста (моргающий хост).
            if (rawSteps.length === 0) return undefined
            return {
              scenarioId: Number(offboarding.scenario_id),
              steps: rawSteps.map(step => ({
                type: step.type as StepType,
                sort: Number(step.sort),
                config: normalizeConfig(step.config),
                presentation: step.presentation as Presentation | undefined,
                chain: step.chain === 1 || step.chain === 2 ? step.chain : undefined
              }))
            } satisfies OffboardingScenario
          }
        }
      }
    }) as RawSubscription

    if (!convertedData.nextPayAt && convertedData.endDate) {
      convertedData.nextPayAt = Time(convertedData.endDate, 'YYYY-MM-DD')
        .set('hours', 0)
        .set('minutes', 0)
        .set('seconds', 0)
        .set('milliseconds', 0)
        .unix() * 1000
    }

    return convertedData
  }
}
